import { setPageGroupData } from "../../../features/pageGroupSlice";
import { setDisplayErrorSnackBar } from "../../../features/userSlice";
import { pageGroupServices } from "../../../services/api/page-group.endpoints";
import { setLoading } from "../../../features/assetManagementSlice";
import store from "../../../store";

async function getAllPageGroupsDuplicate(
  oauthTokenHeader: string,
  website_shared_uid: any,
  dispatch: any,
) {
  try {
    const response = await pageGroupServices.getAllPageGroups(
      oauthTokenHeader,
      website_shared_uid,
    );
    if (!response || !response.status || response.status !== 200) {
      throw new Error("Failed to get page content");
    } else {
      // setPageGroups(response?.data?.data); // Set the fetched data
      dispatch(setPageGroupData(response?.data?.data));
    }
  } catch (e: any) {
    store.dispatch(
      setDisplayErrorSnackBar({
        message: e?.parsedText || "Unknown error occurred",
        type: "error",
      }),
    );
  }
}

async function getAllPageGroups(
  oauthTokenHeader: string,
  website_shared_uid: any,
  setPageGroups: any,
) {
  try {
    const response = await pageGroupServices.getAllPageGroups(
      oauthTokenHeader,
      website_shared_uid,
    );
    if (!response || !response.status || response.status !== 200) {
      throw new Error("Failed to get page content");
    } else {
      setPageGroups(response?.data?.data); // Set the fetched data
    }
  } catch (e: any) {
    store.dispatch(
      setDisplayErrorSnackBar({
        message: e?.parsedText || "Unknown error occurred",
        type: "error",
      }),
    );
  }
}

async function getSinglePageGroup(
  oauthTokenHeader: string,
  website_shared_uid: any,
  page_shared_uid: any,
  setSinglePageGroup: any,
) {
  try {
    const response = await pageGroupServices.getSinglePageGroup(
      oauthTokenHeader,
      website_shared_uid,
      page_shared_uid,
    );
    if (!response || !response.status || response.status !== 200) {
      throw new Error("Failed to get page content");
    } else {
      setSinglePageGroup(response?.data?.data[0]); // Set the fetched data
    }
  } catch (e: any) {
    store.dispatch(
      setDisplayErrorSnackBar({
        message: e?.parsedText || "Unknown error occurred",
        type: "error",
      }),
    );
  }
}

async function getAllThemes(
  oauthTokenHeader: any,
  website_shared_uid: any,
  setThemes: any,
) {
  try {
    const response = await pageGroupServices.getAllThemes(
      oauthTokenHeader,
      website_shared_uid,
    );
    if (!response || !response.status || response.status !== 200) {
      throw new Error("Failed to get themes");
    } else {
      setThemes(response?.data?.data); // Set the fetched data
    }
  } catch (e: any) {
    store.dispatch(
      setDisplayErrorSnackBar({
        message: e?.parsedText || "Unknown error occurred",
        type: "error",
      }),
    );
  }
}

async function getAllPopups(
  oauthTokenHeader: any,
  website_shared_uid: any,
  setPageGroups: any,
) {
  try {
    const response = await pageGroupServices.getPopupOffers(
      oauthTokenHeader,
      website_shared_uid,
    );
    if (!response || !response.status || response.status !== 200) {
      throw new Error("Failed to get popups");
    } else {
      setPageGroups(response?.data?.data?.widgets); // Set the fetched data
    }
  } catch (e: any) {
    store.dispatch(
      setDisplayErrorSnackBar({
        message: e?.parsedText || "Unknown error occurred",
        type: "error",
      }),
    );
  }
}

async function getWebsiteAttributeDetails(
  oauthTokenHeader: any,
  website_shared_uid: any,
  setAttributeDetails: any,
) {
  try {
    const response = await pageGroupServices.getWebsiteAttributeDetails(
      oauthTokenHeader,
      website_shared_uid,
    );
    if (!response || !response.status || response.status !== 200) {
      throw new Error("Failed to get site attribute");
    } else {
      setAttributeDetails(response?.data?.data); // Set the fetched data
    }
  } catch (e: any) {
    store.dispatch(
      setDisplayErrorSnackBar({
        message: e?.parsedText || "Unknown error occurred",
        type: "error",
      }),
    );
  }
}

async function postImageUpload(
  oauthTokenHeader: any,
  website_shared_uid: any,
  setImagePath: any,
  data: any,
) {
  try {
    const response = await pageGroupServices.uploadImage(
      oauthTokenHeader,
      data,
      website_shared_uid,
    );
    if (!response || !response.status || response.status !== 200) {
      throw new Error("Failed to get site attribute");
    } else {
      setImagePath(response?.data?.data[0]?.upload_path); // Set the fetched data
    }
  } catch (e: any) {
    const is500Error = e?.status === 500 || e?.response?.status === 500;
    const rawMessage = e?.parsedText || e?.message || "Unknown error occurred";
    const isLongMessage = rawMessage.length > 100;

    const displayMessage =
      is500Error && isLongMessage
        ? "Internal Server Error: The server encountered an unexpected issue. Please try again."
        : rawMessage;

    store.dispatch(
      setDisplayErrorSnackBar({
        message: displayMessage,
        type: "error",
      }),
    );
  }
}

async function createPageGroup(
  oauthTokenHeader: any,
  website_shared_uid: any,
  setPageGroup: any,
  data: any,
  action?: string
) {
  try {
    const response = await pageGroupServices.createPageGroup(
      oauthTokenHeader,
      data,
      website_shared_uid,
    );
    if (!response || !response.status || response.status !== 201) {
      throw new Error("Failed to get site attribute");
    } else {
      store.dispatch(
        setDisplayErrorSnackBar({
          message: `Page Group ${action} Successfully`,
          type: "success",
        })
      );
      setPageGroup(response?.data?.data); // Set the fetched data
      return response;
    }
  } catch (e: any) {
    setPageGroup([]); // Set the fetched data
    store.dispatch(
      setDisplayErrorSnackBar({
        message: e?.parsedText || "Unknown error occurred",
        type: "error",
      }),
    );
  }
}

async function editPageGroup(
  oauthTokenHeader: any,
  website_shared_uid: any,
  page_group_uid: any,
  data: any,
  setUpdatedPageGroupData: any,
) {
  try {
    const response = await pageGroupServices.editPageGroup(
      oauthTokenHeader,
      data,
      website_shared_uid,
      page_group_uid,
    );
    if (!response || !response.status || response.status !== 200) {
      throw new Error("Failed to get site attribute");
    } else {
      // Set the fetched data
      setUpdatedPageGroupData(response?.data?.data);
      return response;
    }
  } catch (e: any) {
    store.dispatch(
      setDisplayErrorSnackBar({
        message: e?.parsedText || "Page Group Updation Failed",
        type: "error",
      }),
    );
  }
}

async function toggleStatusPageGroup(
  oauthTokenHeader: string,
  data: any,
  website_shared_uid: any,
  page_group_uid: any,
  setTogglePageSpeedData: any,
) {
  try {
    const response = await pageGroupServices.toggleStatusPageGroup(
      oauthTokenHeader,
      data,
      website_shared_uid,
      page_group_uid,
    );
    if (!response || !response.status || response.status !== 200) {
      store.dispatch(
        setDisplayErrorSnackBar({
          message: "Something went wrong while Getting Page Content",
          type: "error",
        }),
      );
    } else {
      setTogglePageSpeedData([response?.data?.data]);
    }
  } catch (e: any) {
    // Only dispatch if it's not already dispatched above
    if (e?.message) {
      store.dispatch(
        setDisplayErrorSnackBar({
          message: e?.parsedText || "Unknown error occurred",
          type: "error",
        }),
      );
    }
    throw e; // Re-throw to let calling code handle it
  }
}

async function getAllPages(
  oauthTokenHeader: string,
  website_shared_uid: any,
  setPages: any,
) {
  try {
    let allPages: any[] = [];
    let nextUrl: string | null = null;

    // Step 1: initial request
    const response = await pageGroupServices.getAllPages(
      oauthTokenHeader,
      website_shared_uid,
    );

    if (!response || response.status !== 200) {
      throw new Error("Failed to get pages");
    }

    const data = response.data?.data;
    if (!data) {
      throw new Error("Invalid response data");
    }

    // Add first batch
    allPages = [...(data.records || [])];
    nextUrl = data.next;

    // Step 2: fetch next pages using getNextPages
    while (nextUrl) {
      const nextResponse = await pageGroupServices.getNextPages(
        nextUrl,
        oauthTokenHeader,
      );
      if (!nextResponse || nextResponse.status !== 200) {
        throw new Error("Failed to fetch next page");
      }
      const nextData = nextResponse.data?.data;
      if (!nextData) break;
      allPages = [...allPages, ...(nextData.records || [])];
      nextUrl = nextData.next; // move to next page (or null)
    }

    // Step 3: set final merged pages
    setPages(allPages);
  } catch (e: any) {
    store.dispatch(
      setDisplayErrorSnackBar({
        message: e?.message || "Unknown error occurred",
        type: "error",
      }),
    );
  }
}

async function assignPageGroupToPages(
  data: any,
  website_shared_uid: any,
  oauthTokenHeader: any,
) {
  try {
    store.dispatch(setLoading(true));
    const response = await pageGroupServices.assignPageGroupToPages(
      data,
      website_shared_uid,
      oauthTokenHeader,
    );
    if (!response || !response.status || response.status !== 200) {
      store.dispatch(
        setDisplayErrorSnackBar({
          message: "Something went wrong while Getting Page Groups",
          type: "error",
        }),
      );
    } else {
      if (response?.status === 200) {
        // store.dispatch(setDisplayErrorSnackBar({ message: "Page group Assigned Successfully", type: "success" }));
      }
      return response;
    }
  } catch (e: any) {
    let rawMessage = e?.parsedText || e?.message || "Unknown error occurred"; // Extract a readable error text

    // Strip long HTML/JSON if present
    rawMessage = String(rawMessage)
      .replace(/<[^>]+>/g, "") // remove HTML tags
      .replace(/\s+/g, " ") // collapse whitespace
      .trim();

    // Truncate VERY LONG messages
    const maxLength = 120;
    const shortMessage =
      rawMessage.length > maxLength
        ? rawMessage.substring(0, maxLength) + "..."
        : rawMessage;

    store.dispatch(
      setDisplayErrorSnackBar({ message: shortMessage, type: "error" }),
    );
  } finally {
    store.dispatch(setLoading(false));
  }
}

async function pageGroupLinks(
  oauthTokenHeader: any,
  page_group_uid: any,
  data: any,
) {
  try {
    const response = await pageGroupServices.pageGroupLinks(
      oauthTokenHeader,
      data,
      page_group_uid,
    );
    if (!response || !response.status || response.status !== 200) {
      throw new Error("Failed to get site attribute");
    } else {
      // Set the fetched data
      return response;
    }
  } catch (e: any) {
    store.dispatch(
      setDisplayErrorSnackBar({
        message:
          e?.parsedText ||
          "Comperasion Table or Traffic Source Updation Failed",
        type: "error",
      }),
    );
  }
}

export const PageGroupEndPointLogic = {
  getAllPageGroups,
  getSinglePageGroup,
  getAllThemes,
  getAllPopups,
  getWebsiteAttributeDetails,
  postImageUpload,
  createPageGroup,
  editPageGroup,
  toggleStatusPageGroup,
  getAllPageGroupsDuplicate,
  getAllPages,
  assignPageGroupToPages,
  pageGroupLinks,
};
